export const enum EConvertType { // ALSO CHECK IN utils/validator.ts > CheckConvertTypeCompatible
    SrtToFCPXML = 'SrtToFCPXML',
    SrtToAvidSubCap = 'SrtToAvidSubCap',
    SrtToWebVTT = 'SrtToWebVTT',
    WebVTTToSrt = 'WebVTTToSrt',
    XMLToFCPXML = 'XMLToFCPXML',
    FCPXMLToXML = 'FCPXMLToXML',
    SrtToEDL = 'SrtToEDL'
};

export interface IConvertConfig {
    width?: number;
    height?: number;
    fps?: number;
}